import { React, useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";

import "./supAdmin.css";

import Calendar from "react-calendar";
import "../../../custom-css/calendar.css";

import TodaysScheduleTimimg from "./StatsDataContent/TodaysScheduleTimimg";
import BookingReqData from "./StatsDataContent/BookingReqData";
import PendingBookingData from "./StatsDataContent/PendingBookingData";
import ConfirmBookingData from "./StatsDataContent/ConfirmBookingData";
import ClientsCountData from "./StatsDataContent/ClientsCountData";
import TraineesCountData from "./StatsDataContent/TraineesCountData";

import AuthService from "../../../services/auth.service";

const Dashboard = () => {

  const [value, onChange] = useState(new Date());

  const [statsData, setStatsData] = useState("one");

  const showStatsData = (count) => {
    setStatsData(count);
  };

  const [roll, setroll] = useState("");

  useEffect(() => {
    const user = AuthService.getCurrentUser();
    console.log(user.user_id);

    setroll(user.user_id);
  }, []);

  return (
    <>
      <Container fluid>
        <Row>
          <Col xl={9} lg={9} md={12} sm={12}>
  
            <div className="stats-list">
              {/* stats-box */}
              <div
                className={
                  statsData === "one" ? "stats-box active" : "stats-box"
                }
                onClick={() => showStatsData("one")}
              >
                <div className="box-outer">
                  <svg
                    id="scheduledTiming"
                    xmlns="http://www.w3.org/2000/svg"
                    width="39.84"
                    height="41.455"
                    viewBox="0 0 56 58.269"
                  >
                    <path
                      id="Path_430"
                      data-name="Path 430"
                      d="M42.22,58.269h-2.5a3.07,3.07,0,0,0-.378-.1A14.756,14.756,0,0,1,27.81,50.4a1.226,1.226,0,0,0-1.266-.73c-7.76.02-15.522.009-23.282.017a3.155,3.155,0,0,1-2.476-.91A3.2,3.2,0,0,1,0,46.418q.009-15.675,0-31.35,0-3.7.008-7.4a2.984,2.984,0,0,1,3.12-3.167c.492-.012.985,0,1.476,0H6.9V2.9A2.925,2.925,0,0,1,9.165,0H10.3c2.185.744,2.349,2.513,2.141,4.461H36.975c0-.624-.009-1.214,0-1.792A2.558,2.558,0,0,1,38.027.616,8.449,8.449,0,0,1,39.15,0h1.135c2.258.7,2.419,2.493,2.228,4.5h.69c1.021,0,2.044-.012,3.065,0a2.988,2.988,0,0,1,3.171,3.171q.032,3.158.027,6.316,0,8.108-.032,16.214a.942.942,0,0,0,.432.841,14.72,14.72,0,0,1,6.1,13.176A14.921,14.921,0,0,1,45.043,57.693C44.121,57.952,43.162,58.081,42.22,58.269ZM1.821,14.924v31.47c0,1.174.3,1.469,1.49,1.469H26.025c.2,0,.4-.017.586-.027-1.6-6.267-.341-11.745,4.552-15.992s10.47-4.73,16.41-2.261V14.924ZM54.172,42.3a13.278,13.278,0,0,0-3.285-7.882c-.178.24-.291.417-.428.574a6.562,6.562,0,0,1-.48.484.914.914,0,1,1-1.272-1.285c.325-.3.7-.566,1.091-.877A13.251,13.251,0,0,0,41.89,30v1.366c-.011.636-.347,1.036-.873,1.062s-.926-.411-.941-1.062c-.011-.446,0-.894,0-1.341-2.593.032-6.338,1.61-7.739,3.269.284.266.58.528.859.807.534.537.592,1.082.173,1.484s-.91.346-1.432-.185c-.288-.294-.548-.616-.819-.924-1.8,1.745-3.525,5.974-3.223,7.827h1.232c.7.009,1.082.314,1.1.873s-.378.926-1.1.944c-.428.012-.856,0-1.32,0a13.41,13.41,0,0,0,3.285,7.839c.175-.219.3-.4.455-.574s.316-.328.481-.483a.9.9,0,0,1,1.357-.073.911.911,0,0,1-.086,1.366c-.317.32-.678.6-1.055.929A13.227,13.227,0,0,0,39.993,56.4c.035-.067.067-.1.068-.132,0-.417,0-.833.02-1.25a.952.952,0,0,1,.9-1.042c.545-.014.91.4.918,1.062v1.373a13.252,13.252,0,0,0,7.812-3.267c-.363-.341-.687-.628-.991-.938a.933.933,0,0,1-.1-1.4.9.9,0,0,1,1.357.106c.319.311.607.651.953,1.015a13.3,13.3,0,0,0,3.243-7.819c-.545,0-1.015.024-1.483,0a.9.9,0,1,1,.059-1.8C53.2,42.289,53.649,42.3,54.172,42.3ZM12.482,6.364c0,.455.011.863,0,1.276a5.231,5.231,0,0,1-.088,1.071A2.768,2.768,0,0,1,9.36,10.8,2.812,2.812,0,0,1,6.909,8.1c-.021-.58,0-1.161,0-1.774H3.3c-1.074,0-1.473.407-1.478,1.483,0,1.557,0,3.12,0,4.666,0,.164.023.326.036.493H47.6c0-1.9.02-3.75-.012-5.6a.953.953,0,0,0-.926-.988c-1.354-.047-2.709-.015-4.117-.015,0,.566.008,1.094,0,1.621a2.745,2.745,0,0,1-.974,2.156,2.647,2.647,0,0,1-2.917.455,2.6,2.6,0,0,1-1.669-2.428c-.027-.595,0-1.193,0-1.792Zm26.3-.939V7.871c0,.7.354,1.1.933,1.123a1,1,0,0,0,1.008-1.12q.014-2.476,0-4.95a1,1,0,0,0-.974-1.1.981.981,0,0,0-.964,1.1c-.011.835,0,1.669,0,2.5ZM10.665,5.407V2.961c0-.712-.393-1.149-.983-1.137a1.008,1.008,0,0,0-.956,1.118q-.011,2.475,0,4.95a.984.984,0,0,0,.967,1.1.968.968,0,0,0,.971-1.085C10.672,7.074,10.663,6.24,10.665,5.407Z"
                    />
                    <path
                      id="Path_431"
                      data-name="Path 431"
                      d="M29.719,119.667V116.71a.943.943,0,0,1,1.076-1.088q2.982-.014,5.96,0c.744,0,1.074.332,1.079,1.085q.018,2.986,0,5.971c0,.774-.341,1.088-1.132,1.091q-2.923.009-5.847,0c-.812,0-1.134-.332-1.137-1.144C29.714,121.64,29.719,120.654,29.719,119.667Zm6.262-2.2h-4.41v4.451h4.41Z"
                      transform="translate(-25.207 -98.071)"
                    />
                    <path
                      id="Path_432"
                      data-name="Path 432"
                      d="M246.7,123.809h-2.951c-.815,0-1.14-.322-1.143-1.14q-.014-2.93,0-5.857c0-.845.325-1.15,1.188-1.152h5.733c.888,0,1.2.314,1.2,1.2v5.8c0,.816-.325,1.144-1.132,1.152C248.626,123.815,247.664,123.809,246.7,123.809Zm-2.218-6.3v4.434h4.4v-4.434Z"
                      transform="translate(-205.783 -98.109)"
                    />
                    <path
                      id="Path_433"
                      data-name="Path 433"
                      d="M37.851,248.134c0,.968.009,1.935,0,2.9-.009.813-.331,1.126-1.152,1.127H30.854c-.781,0-1.117-.335-1.12-1.1q-.009-2.986,0-5.971c0-.712.326-1.062,1.038-1.062q3.035-.026,6.07,0c.678,0,.992.349,1,1.042C37.863,246.087,37.85,247.111,37.851,248.134Zm-6.275,2.161h4.416v-4.429H31.577Z"
                      transform="translate(-25.219 -206.987)"
                    />
                    <path
                      id="Path_434"
                      data-name="Path 434"
                      d="M100.745,119.669v-2.957c0-.715.328-1.062,1.032-1.062q3.008-.018,6.015,0a.917.917,0,0,1,1.05,1.049q.014,3.014,0,6.029c0,.744-.332,1.062-1.086,1.062q-2.951.014-5.9,0c-.786,0-1.1-.328-1.108-1.108C100.739,121.678,100.745,120.673,100.745,119.669Zm1.841,2.264h4.4V117.5h-4.4Z"
                      transform="translate(-85.455 -98.092)"
                    />
                    <path
                      id="Path_435"
                      data-name="Path 435"
                      d="M171.711,119.6v-2.957c.009-.719.326-1.053,1.041-1.062q3.006-.018,6.017,0c.707,0,1.038.349,1.041,1.062q.011,3.014,0,6.029a.929.929,0,0,1-1.042,1.062q-3.009.018-6.017,0c-.713,0-1.032-.337-1.039-1.062C171.7,121.646,171.711,120.623,171.711,119.6Zm6.262-2.161h-4.4v4.437h4.4Z"
                      transform="translate(-145.652 -98.033)"
                    />
                    <path
                      id="Path_436"
                      data-name="Path 436"
                      d="M100.735,248.034c0-1-.008-2.011,0-3.015a.9.9,0,0,1,1-1.035q3.035-.027,6.07,0c.713,0,1.017.346,1.02,1.077q.012,2.983,0,5.97c0,.777-.328,1.093-1.117,1.1q-2.923.009-5.847,0c-.818,0-1.13-.319-1.135-1.135Q100.73,249.512,100.735,248.034Zm1.848,2.226h4.4v-4.432h-4.4Z"
                      transform="translate(-85.445 -206.949)"
                    />
                    <path
                      id="Path_437"
                      data-name="Path 437"
                      d="M33.812,179.927h2.951c.733,0,1.071.3,1.077,1.014q.023,3.044,0,6.085a.9.9,0,0,1-1.02,1.014q-3.035.014-6.07,0a.9.9,0,0,1-1.02-1.014q-.014-3.035,0-6.083a.9.9,0,0,1,1.02-1.014C31.77,179.921,32.791,179.927,33.812,179.927Zm-2.253,6.25h4.429v-4.387H31.559Z"
                      transform="translate(-25.214 -152.622)"
                    />
                    <path
                      id="Path_438"
                      data-name="Path 438"
                      d="M108.853,183.963v2.956c0,.759-.3,1.08-1.062,1.083q-2.98.014-5.957,0c-.785,0-1.082-.316-1.083-1.118v-5.918c0-.759.313-1.08,1.062-1.082q3.009-.009,6.015,0a.888.888,0,0,1,1.023,1C108.862,181.916,108.852,182.941,108.853,183.963Zm-1.844-2.218H102.6v4.4h4.411Z"
                      transform="translate(-85.462 -152.584)"
                    />
                    <path
                      id="Path_439"
                      data-name="Path 439"
                      d="M256.088,232.407c0,.739-.023,1.48.015,2.215a1.059,1.059,0,0,0,.328.558,10.9,10.9,0,0,1,1.062,1.073.759.759,0,0,0,.722.387c1.135-.015,2.269-.018,3.4,0,.681.014,1.073.455.982,1.033-.076.495-.413.768-1.023.774q-1.7.021-3.4,0a.645.645,0,0,0-.666.379,2.633,2.633,0,0,1-2.768,1.352,2.712,2.712,0,0,1-2.176-2.129,2.619,2.619,0,0,1,1.343-2.827.635.635,0,0,0,.366-.665q-.017-2.19,0-4.376c0-.733.475-1.178,1.085-1.044a.866.866,0,0,1,.728.941C256.088,230.854,256.087,231.63,256.088,232.407Zm-.91,5.983a.794.794,0,0,0,.815-.83.8.8,0,0,0-.786-.86.845.845,0,1,0-.029,1.69Z"
                      transform="translate(-214.198 -194.348)"
                    />
                  </svg>
                </div>
                <div className="box-header">
                  <h2>Today's Scheduled Timing</h2>
                </div>
              </div>
              {/* stats-box */}
              <div
                className={
                  statsData === "two" ? "stats-box active" : "stats-box"
                }
                onClick={() => showStatsData("two")}
              >
                <div className="box-outer">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="46.766"
                    height="41.26"
                    viewBox="0 0 65.733 58"
                  >
                    <g id="booking-Req" transform="translate(-0.001 -0.01)">
                      <g
                        id="Layer_1"
                        data-name="Layer 1"
                        transform="translate(0.001 0.01)"
                      >
                        <path
                          id="Path_405"
                          data-name="Path 405"
                          d="M4.208,42.171V1.81c0-.27,0-.541.014-.811A.956.956,0,0,1,5.2.017c.2-.016.4,0,.6,0H59.963c1.346,0,1.571.227,1.571,1.609V42.171h2.875c1.062,0,1.352.3,1.323,1.353A8.529,8.529,0,0,1,57.3,51.7q-2.548.032-5.1,0c-.515,0-.743.1-.867.681a6.824,6.824,0,0,1-6.771,5.607c-4.524.027-9.05.018-13.574,0a6.593,6.593,0,0,1-5.435-2.733c-.761-.995-1.548-1.966-2.284-2.978a1.079,1.079,0,0,0-1-.479q-6.854.018-13.707,0A8.414,8.414,0,0,1,.086,44.524c0-.022-.012-.043-.014-.065-.177-1.843-.172-2.4,1.875-2.288C2.673,42.207,3.4,42.171,4.208,42.171Zm55.256-40H6.3V42.139h9.041c-.2-.252-.345-.438-.49-.625a3.431,3.431,0,0,1,.161-4.5,5.738,5.738,0,0,1,3.931-1.859c2.212-.108,3.793,1.094,5.181,2.672.147.168.29.335.531.614V37.5c0-6.036-.011-12.072,0-18.11a4.1,4.1,0,1,1,8.2-.014c.027,2.141,0,4.281,0,6.42v.708a4.086,4.086,0,0,1,5.662,1.459c2.951-1.728,5.37-.818,6.723,2.485,3.118-1.665,6.5.721,6.23,4.373-.145,2.016-.027,4.052-.027,6.079v1.229h8ZM26.8,30.407V41.429a1.073,1.073,0,0,1-.646,1.081.929.929,0,0,1-1.182-.317c-.364-.452-.69-.937-1.062-1.377a26.855,26.855,0,0,0-2.394-2.687,3.268,3.268,0,0,0-4.275-.281,1.528,1.528,0,0,0-.449,2.573q5.045,6.624,10.1,13.281A5.4,5.4,0,0,0,31.5,56.016c4.214-.025,8.431,0,12.647-.011,3.238,0,5.276-2.112,5.278-5.42V34.5a5.774,5.774,0,0,0-.012-.607,2.062,2.062,0,0,0-2.164-1.845,1.911,1.911,0,0,0-1.927,1.982c-.014.427.019.858-.018,1.283a.974.974,0,0,1-1.481.852,1.6,1.6,0,0,1-.552-1.11c-.071-1.3,0-2.611-.042-3.917A1.916,1.916,0,0,0,41.3,29.171a1.993,1.993,0,0,0-2.153,2.182c-.025,1.283,0,2.568-.014,3.851-.011.755-.442,1.15-1.124,1.081-.593-.056-.894-.407-.9-1.112-.012-1.69.016-3.38-.014-5.069A2,2,0,0,0,34.991,28,1.975,1.975,0,0,0,33,30.135c-.016,1.126,0,2.252,0,3.378,0,.586.021,1.173-.011,1.757a1.027,1.027,0,0,1-2.054.032,6.572,6.572,0,0,1-.011-.674q0-7.5,0-15a2.133,2.133,0,0,0-1.29-2.151A2.079,2.079,0,0,0,26.82,19.6C26.79,23.2,26.8,26.8,26.8,30.407ZM21.21,49.717c-.177-.265-.285-.431-.4-.584-1.118-1.452-2.251-2.892-3.351-4.357A1.171,1.171,0,0,0,16.4,44.25c-4.524.018-9.048.011-13.574.013-.232,0-.462.025-.757.041.065.3.1.514.161.721A6.381,6.381,0,0,0,8.1,49.694C12.427,49.777,16.753,49.717,21.21,49.717ZM51.6,44.312v5.342c2.213,0,4.4.166,6.559-.041,2.75-.263,4.478-2.009,5.352-4.649a5.522,5.522,0,0,0,.136-.652Z"
                          transform="translate(-0.001 -0.01)"
                        />
                        <path
                          id="Path_406"
                          data-name="Path 406"
                          d="M233.22,50.539h-7.171a2.025,2.025,0,0,1-.724-.107.954.954,0,0,1-.619-1.086.9.9,0,0,1,.876-.876,4.1,4.1,0,0,1,.472-.022h14.408c.568,0,1.105.049,1.3.724.228.8-.252,1.377-1.165,1.379C238.134,50.539,235.677,50.539,233.22,50.539Z"
                          transform="translate(-185.522 -39.684)"
                        />
                        <path
                          id="Path_407"
                          data-name="Path 407"
                          d="M243.876,91.234h-6.288c-.563,0-1.039-.125-1.189-.76-.181-.791.264-1.321,1.153-1.324h12.642a1.027,1.027,0,0,1,1.162,1.1c-.022.669-.4.975-1.194.979C248.067,91.24,245.971,91.234,243.876,91.234Z"
                          transform="translate(-195.082 -73.091)"
                        />
                        <path
                          id="Path_408"
                          data-name="Path 408"
                          d="M265.007,131.942h-4.12c-.859,0-1.267-.362-1.267-1.06s.416-1.049,1.267-1.051h8.242c.823,0,1.267.389,1.267,1.069s-.413,1.037-1.279,1.042C267.755,131.947,266.383,131.942,265.007,131.942Z"
                          transform="translate(-214.134 -106.442)"
                        />
                        <path
                          id="Path_409"
                          data-name="Path 409"
                          d="M66.2,131.942h-3.38c-.868,0-1.285-.349-1.3-1.037s.429-1.073,1.323-1.075h6.827c.85,0,1.292.362,1.306,1.033s-.441,1.073-1.332,1.086C68.494,131.947,67.345,131.942,66.2,131.942Z"
                          transform="translate(-50.675 -106.442)"
                        />
                        <path
                          id="Path_410"
                          data-name="Path 410"
                          d="M66.181,89.129h3.438c.84,0,1.283.375,1.267,1.051s-.432,1.028-1.229,1.03q-3.512.013-7.026,0c-.792,0-1.207-.384-1.2-1.049s.422-1.024,1.221-1.031C63.838,89.124,65.009,89.129,66.181,89.129Z"
                          transform="translate(-50.601 -73.072)"
                        />
                        <path
                          id="Path_411"
                          data-name="Path 411"
                          d="M123.606,38.21a2.388,2.388,0,0,1,.711.565c.635.984,1.216,2,1.786,3.025a1.046,1.046,0,0,1-.353,1.476,1.006,1.006,0,0,1-1.464-.362c-.641-1.033-1.267-2.079-1.838-3.15C122.074,39.077,122.611,38.237,123.606,38.21Z"
                          transform="translate(-100.716 -31.298)"
                        />
                        <path
                          id="Path_412"
                          data-name="Path 412"
                          d="M181.193,38.21c.963.027,1.518.827,1.185,1.495-.554,1.1-1.154,2.186-1.786,3.257a.992.992,0,0,1-1.413.342,1.037,1.037,0,0,1-.431-1.4c.543-1.057,1.116-2.106,1.737-3.121C180.661,38.485,181.048,38.324,181.193,38.21Z"
                          transform="translate(-147.067 -31.298)"
                        />
                        <path
                          id="Path_413"
                          data-name="Path 413"
                          d="M155.634,35.959c0-.565-.018-1.129,0-1.692a.991.991,0,0,1,1.055-1.058.965.965,0,0,1,1.008,1.039q.033,1.688,0,3.38a.99.99,0,0,1-1.057,1.06.97.97,0,0,1-1.006-1.039C155.616,37.086,155.634,36.521,155.634,35.959Z"
                          transform="translate(-128.111 -27.201)"
                        />
                      </g>
                    </g>
                  </svg>
                </div>
                <div className="box-header">
                  <h2>Booking Request</h2>
                </div>
              </div>
              {/* stats-box */}
              <div
                className={
                  statsData === "three" ? "stats-box active" : "stats-box"
                }
                onClick={() => showStatsData("three")}
              >
                <div className="box-outer">
                  <svg
                    id="pending-booking"
                    xmlns="http://www.w3.org/2000/svg"
                    width="41.195"
                    height="41.264"
                    viewBox="0 0 57.903 58"
                  >
                    <g id="Layer_1" data-name="Layer 1">
                      <path
                        id="Path_440"
                        data-name="Path 440"
                        d="M57.9,21.07v2.719A8.858,8.858,0,0,1,56.663,25.4a5.392,5.392,0,0,1-1.6.612c.012-.033-.015.018-.023.072-.026.168-.042.337-.062.506a16.452,16.452,0,0,1-5.856,11.058c-1.246,1.047-1.272,2.163-.023,3.188A16.183,16.183,0,0,1,54.5,49.394c.282,1.048.42,2.134.625,3.216.261.044.544.068.813.14A2.837,2.837,0,0,1,57.9,54.828V58H.575A1.437,1.437,0,0,1,0,56.687Q.018,29,0,1.313A1.413,1.413,0,0,1,.575,0H29.293c.213.183.444.347.636.548q5.318,5.551,10.632,11.1a1.661,1.661,0,0,1,.5,1.26c-.018,2.318-.008,4.638-.008,6.958v.643h.736q7.368,0,14.737-.009A1.511,1.511,0,0,1,57.9,21.07ZM1.859,1.834V56.157H28.781c.385-2.769.7-3.164,2.889-3.571.024-.186.056-.387.079-.588A16.481,16.481,0,0,1,37.73,40.766a1.773,1.773,0,0,0,0-3.007,16.075,16.075,0,0,1-5.362-8.135c-.358-1.208-.53-2.459-.8-3.729-.033,0-.124-.024-.216-.033a2.654,2.654,0,0,1-2.521-2.8v-1.3c0-.962.284-1.246,1.246-1.246H39.2V13.452H28.927c-1.029,0-1.311-.285-1.311-1.314V1.834ZM53.142,52.646A.934.934,0,0,0,53.2,52.5a2.224,2.224,0,0,0-.009-.225,14.8,14.8,0,0,0-5.4-10.162,3.545,3.545,0,0,1-.035-5.672,14.932,14.932,0,0,0,5.12-8.254c.184-.734.249-1.5.373-2.266H33.531a3.049,3.049,0,0,0,0,.316,14.835,14.835,0,0,0,5.4,10.165,3.545,3.545,0,0,1,.042,5.672,14.848,14.848,0,0,0-5.092,8.143c-.195.773-.279,1.572-.429,2.432,1.234,0,2.341-.012,3.45.008a.755.755,0,0,0,.73-.394,10.1,10.1,0,0,1,4.43-3.907.805.805,0,0,0,.375-.58c.048-.657,0-1.32.024-1.98a.93.93,0,0,1,.906-1.026c.524,0,.882.394.9,1.023.017.662-.02,1.323.021,1.982a.752.752,0,0,0,.325.557,10.357,10.357,0,0,1,4.561,4.012.642.642,0,0,0,.424.292C50.777,52.656,51.958,52.646,53.142,52.646Zm2.941-30.281h-25.4c-.131,1.462.068,1.689,1.452,1.689H54.667c.207,0,.415.008.621-.012a.814.814,0,0,0,.791-.807c.027-.276,0-.559,0-.87ZM30.651,56.151h25.4c.127-1.485-.062-1.692-1.51-1.692H32.066c-.207,0-.415-.008-.621.012a.811.811,0,0,0-.79.807C30.63,55.558,30.651,55.839,30.651,56.151Zm7.363-44.536L29.485,2.7v8.911ZM39.6,52.6h7.529a8.547,8.547,0,0,0-3.021-2.513,1.483,1.483,0,0,0-1.5,0A8.428,8.428,0,0,0,39.6,52.6Z"
                      />
                      <path
                        id="Path_441"
                        data-name="Path 441"
                        d="M58.358,220.194H48.7a4.684,4.684,0,0,1-.565-.012.834.834,0,0,1-.788-.822.817.817,0,0,1,.616-.906,2.347,2.347,0,0,1,.668-.073H68.114a2.115,2.115,0,0,1,.719.1.805.805,0,0,1,.535.95.814.814,0,0,1-.734.743,3.5,3.5,0,0,1-.563.018Z"
                        transform="translate(-40.188 -185.395)"
                      />
                      <path
                        id="Path_442"
                        data-name="Path 442"
                        d="M58.373,283.414H68.09a3.786,3.786,0,0,1,.508.011.823.823,0,0,1,.784.755.814.814,0,0,1-.592.967,2.446,2.446,0,0,1-.722.074H48.406c-.648-.023-1.069-.391-1.057-.927s.414-.882,1.086-.884Z"
                        transform="translate(-40.197 -240.603)"
                      />
                      <path
                        id="Path_443"
                        data-name="Path 443"
                        d="M55.512,153.593h6.833a3.792,3.792,0,0,1,.508.014.887.887,0,0,1,.154,1.725,2.339,2.339,0,0,1-.668.069H48.448c-.7-.017-1.13-.369-1.128-.92s.414-.89,1.133-.891Q51.983,153.59,55.512,153.593Z"
                        transform="translate(-40.173 -130.391)"
                      />
                      <path
                        id="Path_444"
                        data-name="Path 444"
                        d="M55.446,90.35H48.33a.908.908,0,0,1-1.01-.906.942.942,0,0,1,.968-.906c.131-.009.263,0,.394,0H62.237a4.379,4.379,0,0,1,.563.014.893.893,0,0,1,.829.959.873.873,0,0,1-.906.829c-.621.017-1.243,0-1.864,0Z"
                        transform="translate(-40.172 -75.161)"
                      />
                      <path
                        id="Path_445"
                        data-name="Path 445"
                        d="M246.854,187a6.829,6.829,0,0,0,4.752-.881,9.419,9.419,0,0,1,3.453-1.146,5.443,5.443,0,0,1,3.667,1.208.869.869,0,0,1,.269,1.16,10.736,10.736,0,0,1-5.234,5.543.8.8,0,0,0-.58.932,2.768,2.768,0,0,1-.018.733.885.885,0,0,1-1.757,0,4.4,4.4,0,0,1-.021-.906.6.6,0,0,0-.426-.692,9.923,9.923,0,0,1-4.738-4.427,1.337,1.337,0,0,1-.05-1.038C246.271,187.245,246.67,187.124,246.854,187Zm1.849,1.942a7.977,7.977,0,0,0,3.462,2.589.4.4,0,0,0,.311-.035,17.725,17.725,0,0,0,2.127-1.258,8.422,8.422,0,0,0,2.4-3,3.371,3.371,0,0,0-3.037-.18c-1.725.663-3.3,1.72-5.265,1.888Z"
                        transform="translate(-208.92 -157.028)"
                      />
                      <path
                        id="Path_446"
                        data-name="Path 446"
                        d="M282.972,262.195a4.117,4.117,0,0,1-.053.569.813.813,0,0,1-.849.675.786.786,0,0,1-.858-.657,4.078,4.078,0,0,1-.017-1.174.88.88,0,0,1,1.737.03A4.8,4.8,0,0,1,282.972,262.195Z"
                        transform="translate(-238.694 -221.479)"
                      />
                    </g>
                  </svg>
                </div>
                <div className="box-header">
                  <h2>Pending Booking</h2>
                </div>
              </div>
              {/* stats-box */}
              <div
                className={
                  statsData === "four" ? "stats-box active" : "stats-box"
                }
                onClick={() => showStatsData("four")}
              >
                <div className="box-outer">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="37.113"
                    height="41.264"
                    viewBox="0 0 52.165 58"
                  >
                    <g id="confirm-booking" transform="translate(0 0.01)">
                      <g
                        id="Layer_1"
                        data-name="Layer 1"
                        transform="translate(0 -0.01)"
                      >
                        <path
                          id="Path_447"
                          data-name="Path 447"
                          d="M2.028,13.574H12.491a1,1,0,0,0,1.076-1.054q.012-3.3,0-6.6a1,1,0,0,0-.983-1.029A1.029,1.029,0,0,0,11.6,5.917q0,2.491,0,4.983v.666H3.611l-.116-.12c.622-.579,1.263-1.139,1.864-1.738q3.074-3.074,6.12-6.18c.425-.427.832-.875,1.28-1.275a1.07,1.07,0,0,1,.649-.259q14.363-.021,28.725-.01c.112,0,.224.01.386.019V29.6a2.215,2.215,0,0,0,.209.91.772.772,0,0,0,.966.419,1.018,1.018,0,0,0,.786-.852,4.266,4.266,0,0,0,0-.521c0-9.366-.012-18.733.021-28.1A1.337,1.337,0,0,0,43.02-.01Q28,.042,12.982-.008a1.8,1.8,0,0,0-1.377.6c-1.159,1.159-2.3,2.294-3.44,3.457C7.3,4.932,6.477,5.857,5.6,6.732S3.822,8.414,2.955,9.281c-.668.666-1.288,1.377-1.931,2.063-.089.095-.222.143-.321.23A1.637,1.637,0,0,0,0,12.891q.029,21.9,0,43.8a1.116,1.116,0,0,0,1.259,1.282q13.291-.035,26.583,0c1.159,0,1.253-.672,1.025-1.392a.63.63,0,0,0-.363-.367,2.98,2.98,0,0,0-.85-.1H2.028Z"
                          transform="translate(0 0.01)"
                        />
                        <path
                          id="Path_448"
                          data-name="Path 448"
                          d="M152.391,170.379a14.66,14.66,0,0,0-2.3.168,14.048,14.048,0,0,0-2.65.912,15.837,15.837,0,0,0-2.414,1.352,9.986,9.986,0,0,0-1.634,1.456,14.382,14.382,0,0,0-1.545,1.931,12.706,12.706,0,0,0-1.591,3.7,9.833,9.833,0,0,0-.427,3.727,11.26,11.26,0,0,0,1.174,4.33c.442.811.83,1.661,1.352,2.426a9.246,9.246,0,0,0,1.446,1.591,16.34,16.34,0,0,0,1.891,1.512,12.427,12.427,0,0,0,3.733,1.63,13.993,13.993,0,0,0,5.313.193,7.988,7.988,0,0,0,2.4-.772,19.046,19.046,0,0,0,2.7-1.506,9.45,9.45,0,0,0,1.634-1.475A15.143,15.143,0,0,0,163,189.668a12.575,12.575,0,0,0,1.6-3.689,14.782,14.782,0,0,0,.2-5.315,2.277,2.277,0,0,0-.527-1.329,1.44,1.44,0,0,0-1.159-.095c-.4.1-.566.726-.45,1.1a7.056,7.056,0,0,1,.228,4.1,9.956,9.956,0,0,0-.274,1.325,7.562,7.562,0,0,1-1.06,2.561,9.563,9.563,0,0,1-2.486,2.874,11.054,11.054,0,0,1-2.567,1.528,9.536,9.536,0,0,1-4.764.832,12.313,12.313,0,0,1-3.669-.966,10.74,10.74,0,0,1-3.911-3.022,10.3,10.3,0,0,1-1.528-2.565,9.565,9.565,0,0,1-.834-4.71,12.372,12.372,0,0,1,.966-3.735,11.067,11.067,0,0,1,3.017-3.918,8.3,8.3,0,0,1,2.7-1.586,10.7,10.7,0,0,1,4.55-.772,9.517,9.517,0,0,1,3.731.981,6.834,6.834,0,0,0,1.259.579c.475.149.784-.3.966-.579a1.042,1.042,0,0,0-.12-1.018,14.222,14.222,0,0,0-2.443-1.209A10.261,10.261,0,0,0,152.391,170.379Z"
                          transform="translate(-112.789 -137.467)"
                        />
                        <path
                          id="Path_449"
                          data-name="Path 449"
                          d="M43.719,150.122q-6.133,0-12.269.014a1.487,1.487,0,0,0-.966.348,1.033,1.033,0,0,0-.251.894c.147.3.541.5.857.7.11.071.3.017.456.017H55.913a1.715,1.715,0,0,0,.772-.122c.427-.22.753-.608.55-1.1a1.1,1.1,0,0,0-1.076-.751C52.016,150.128,47.868,150.122,43.719,150.122Z"
                          transform="translate(-24.368 -121.125)"
                        />
                        <path
                          id="Path_450"
                          data-name="Path 450"
                          d="M43.634,122.083H55.9a1.593,1.593,0,0,0,.7-.129.858.858,0,0,0,.539-1.107,1.114,1.114,0,0,0-1.089-.74q-12.414.017-24.828,0a1.08,1.08,0,0,0-1.141,1,1.059,1.059,0,0,0,1.159.966Q37.442,122.087,43.634,122.083Z"
                          transform="translate(-24.279 -96.909)"
                        />
                        <path
                          id="Path_451"
                          data-name="Path 451"
                          d="M43.78,90.12q-6.133,0-12.269.014a1.367,1.367,0,0,0-.91.315,1.092,1.092,0,0,0-.278.939c.129.3.545.489.859.691.1.064.265.015.4.015h24.48a2.161,2.161,0,0,0,.788-.2.751.751,0,0,0,.458-1.027,1.068,1.068,0,0,0-1.025-.738c-2.007.015-4.013,0-6.02,0Z"
                          transform="translate(-24.441 -72.714)"
                        />
                        <path
                          id="Path_452"
                          data-name="Path 452"
                          d="M193.605,183.444c-.209-.245-.386-.632-.618-.682a1.477,1.477,0,0,0-1.159.147c-1,.975-1.914,2.043-2.858,3.078s-1.906,2.086-2.85,3.138q-2.124,2.381-4.249,4.776c-.707.8-.707.827-1.352.054-1.107-1.317-2.186-2.657-3.295-3.973-.321-.386-.72-.755-1.267-.523a.915.915,0,0,0-.647,1.016,1.831,1.831,0,0,0,.386.8c.865,1.033,1.771,2.037,2.644,3.065q.966,1.141,1.891,2.317a.958.958,0,0,0,1.645.089c.836-.946,1.649-1.914,2.511-2.845,1.649-1.8,3.335-3.571,4.979-5.377,1.352-1.477,2.646-2.99,3.959-4.492A3.458,3.458,0,0,0,193.605,183.444Z"
                          transform="translate(-141.44 -147.426)"
                        />
                        <path
                          id="Path_453"
                          data-name="Path 453"
                          d="M40.774,182.112h9.5c.425,0,.784-.1.923-.564.151-.492.16-.966-.353-1.257a1.116,1.116,0,0,0-.523-.145q-9.587-.012-19.169,0a.987.987,0,1,0,.012,1.968Q35.97,182.116,40.774,182.112Z"
                          transform="translate(-24.278 -145.349)"
                        />
                        <path
                          id="Path_454"
                          data-name="Path 454"
                          d="M39.643,210.144H31.251a1.707,1.707,0,0,0-.73.193.806.806,0,0,0-.485,1.029,1.072,1.072,0,0,0,1.074.744H48.243a1.022,1.022,0,0,0,1.1-.966,1.055,1.055,0,0,0-1.132-1Q43.928,210.14,39.643,210.144Z"
                          transform="translate(-24.193 -169.557)"
                        />
                      </g>
                    </g>
                  </svg>
                </div>
                <div className="box-header">
                  <h2>Confirm Booking</h2>
                </div>
              </div>
              {/* stats-box */}
              <div
                className={
                  statsData === "five" ? "stats-box active" : "stats-box"
                }
                onClick={() => showStatsData("five")}
              >
                <div className="box-outer">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="72.95"
                    height="41.264"
                    viewBox="0 0 102.537 58"
                  >
                    <g id="clients" transform="translate(0.015 0.003)">
                      <g
                        id="Layer_1"
                        data-name="Layer 1"
                        transform="translate(-0.015 -0.003)"
                      >
                        <path
                          id="Path_455"
                          data-name="Path 455"
                          d="M26.72,8.432c1.054-3.438,1.054-3.438-2.326-5.03C22.223,2.371,20.046,1.368,17.886.308a1.544,1.544,0,0,0-2.458.842Q7.9,17.221.291,33.228c-.573,1.174-.372,1.9.848,2.452q4.377,1.982,8.7,4.085a1.462,1.462,0,0,0,2.326-.831c.768-1.719,1.587-3.438,2.406-5.122a5.391,5.391,0,0,1,1.1-1.507c0,4.543,1.719,7.448,6.652,7.362.51,3.873,2.716,5.786,6.7,5.592.453,3.483,2.332,5.431,6.01,5.592.195,2.578,1.043,4.824,3.758,5.729s4.784-.206,6.554-2.486A12.164,12.164,0,0,1,46.824,55.5c2.767,3.713,8.645,3.523,10.272-2.223,4.7-.052,5.9-.756,7.356-4.457,3.615,1.083,6.508.292,8.021-3.7,2.143,1.18,4.326,1.621,6.48.252s2.653-3.575,2.292-5.941c1.4-.516,2.721-.894,3.942-1.484A40.46,40.46,0,0,0,88.8,35.772c.521,1.06,1.06,2.045,1.5,3.077.5,1.18,1.186,1.53,2.418.922q4.24-2.08,8.542-4.01c1.255-.573,1.581-1.255.974-2.544q-7.6-15.95-15.091-31.946C86.562.022,85.845-.3,84.574.314q-4.148,2.045-8.382,3.942c-1.329.573-1.719,1.346-.968,2.67a5.97,5.97,0,0,1,.825,2.756A17.83,17.83,0,0,1,74.2,8.764c-3.661-2.343-7.282-4.755-10.971-7.047a4.348,4.348,0,0,0-2.509-.642q-6.783.642-13.5,1.547a3.552,3.552,0,0,0-2.292,1.226C42.544,7.355,39.3,8.782,35.1,8.953,31.452,9.1,29.361,9.274,26.72,8.432ZM38.585,10.77l-3.644,4.039c-.647.722-.94,1.409,0,2.183,3.025,2.538,8.33,2.784,11.109,0a6.537,6.537,0,0,1,5.643-1.925,17.594,17.594,0,0,1,2.4.04,4.457,4.457,0,0,1,2.229.934q10.943,11.138,21.771,22.4A4.36,4.36,0,0,1,79.2,40.493a2.79,2.79,0,0,1-1.558,3.151,3.157,3.157,0,0,1-3.942-.613c-3.518-3.518-7.007-7.064-10.513-10.6-.573-.573-1.255-1.49-2.137-.665s-.029,1.524.573,2.137c2.521,2.567,5.03,5.156,7.585,7.694a3.08,3.08,0,0,1,.882,3.575,3.141,3.141,0,0,1-5.248.951c-3.334-3.22-6.554-6.548-9.894-9.74-.447-.435-1.6-.814-1.931-.573-1.037.773-.12,1.484.458,2.074,2.452,2.481,4.939,4.927,7.391,7.414,1.719,1.719,1.833,3.546.378,4.961-1.364,1.318-3.22,1.18-4.864-.43-2.045-2-4.051-4.01-6.079-6.05A14.323,14.323,0,0,0,48.308,41.9a1.719,1.719,0,0,0-1.478.04c-.195.115-.16.945,0,1.341a4.354,4.354,0,0,0,1.026,1.146c2.017,2.022,4.085,4.01,6.044,6.084a3.054,3.054,0,0,1,0,4.337,3.18,3.18,0,0,1-4.486.132c-.573-.481-1.02-1.094-1.6-1.547-1.226-.985-1.409-1.873-.67-3.375,1.513-2.951.527-5.981-2.211-7.3a17.45,17.45,0,0,0-3.2-.865,4.056,4.056,0,0,1-.195-.516c-.951-3.523-2.67-4.75-6.3-4.681a1.782,1.782,0,0,1-1.26-.911,5.236,5.236,0,0,0-5.506-3.26c-1.054.092-1.335-.338-1.69-1.174a5.323,5.323,0,0,0-9.023-1.61c-.3.309-.653.573-.985.854a1.329,1.329,0,0,1-.132-1.146c2.773-5.9,5.575-11.779,8.307-17.692a1.435,1.435,0,0,1,1.9-.894,25.5,25.5,0,0,0,10.055,0,15.286,15.286,0,0,1,1.684-.092Zm-1.272,4.881a6.09,6.09,0,0,1,.533-.819c2.79-3.1,5.557-6.239,8.428-9.258a3.9,3.9,0,0,1,2.24-.991c3.856-.5,7.723-.934,11.6-1.255a4.721,4.721,0,0,1,2.687.682C66.36,6.2,69.809,8.558,73.367,10.741A24.074,24.074,0,0,0,76.5,11.835a3.191,3.191,0,0,1,1.57,1.232c2.79,5.729,5.511,11.556,8.233,17.348,1.719,3.644,1.719,3.655-1.948,5.58-2.928,1.558-4.337,1.312-6.663-1.089C71.007,28.032,64.3,21.122,57.641,14.2a3.627,3.627,0,0,0-3-1.295c-1.942.092-3.89.086-5.832,0a3.3,3.3,0,0,0-3.059,1.415C43.535,17.112,40.459,17.547,37.313,15.651ZM85.267,2.416l14.827,31.476-7.987,3.73L77.269,6.163Zm-68.017,0C19.656,3.562,21.8,4.6,23.987,5.556c.98.424,1.117.888.67,1.828q-6.875,14.552-13.75,29.133c-.435.928-.9.974-1.719.573C7.47,36.224,5.7,35.371,3.9,34.637c-1.26-.5-1.438-1.054-.842-2.292C7.017,24.1,10.879,15.823,14.786,7.561c.773-1.644,1.57-3.283,2.464-5.139ZM40.722,55c-2.475-.344-4.01-2.549-3.157-4.7a33.935,33.935,0,0,1,2.1-4.3,3.151,3.151,0,0,1,4.263-1.381,3.1,3.1,0,0,1,1.392,4.245,22.917,22.917,0,0,1-2.08,4.114A10.039,10.039,0,0,1,40.722,55ZM39.416,42.085a3.174,3.174,0,0,1-.223.882c-.934,1.616-1.833,3.266-2.91,4.79a2.515,2.515,0,0,1-1.747.808A3.014,3.014,0,0,1,31.5,44.652a18.528,18.528,0,0,1,2.234-4.583A2.8,2.8,0,0,1,37.233,39,3.3,3.3,0,0,1,39.416,42.085Zm-6.875-4.778c-.8,1.61-1.369,2.836-2.005,4.01a3,3,0,0,1-4.045,1.421,3.082,3.082,0,0,1-1.673-4.01,13.177,13.177,0,0,1,1.719-2.945,2.634,2.634,0,0,1,3.483-.951,15.618,15.618,0,0,1,2.532,2.475ZM25,33.3c-.046,1.994-2.045,4.222-3.764,4.194a3.226,3.226,0,0,1-3.145-3.352c.08-2.189,1.891-4.114,3.821-4.051a3.18,3.18,0,0,1,3.1,3.208Z"
                          transform="translate(0.015 0.003)"
                        />
                      </g>
                    </g>
                  </svg>
                </div>
                <div className="box-header">
                {roll === '1' || roll === '3' ? (
                  <h2>No. of Clients</h2>
                ) : roll === '2' ? (
                  <h2>No. of Trainees</h2>
                ) : (
                  <></>
                )}
                </div>
              </div>
              {/* stats-box */}
            </div>
          
            <div className="stats-data">
              <div
                className={
                  statsData === "one" ? "stats-one active" : "stats-one"
                }
              >
                <TodaysScheduleTimimg />
              </div>

              <div
                className={
                  statsData === "two" ? "stats-two active" : "stats-two"
                }
              >
                <BookingReqData />
              </div>
              
              <div
                className={
                  statsData === "three" ? "stats-three active" : "stats-three"
                }
              >
                <PendingBookingData />
              </div>
              
              <div
                className={
                  statsData === "four" ? "stats-four active" : "stats-four"
                }
              >
                <ConfirmBookingData />
              </div>
             
              <div
                className={
                  statsData === "five" ? "stats-five active" : "stats-five"
                }
              >
               {roll === '1' || roll === '3' ? (
                  <ClientsCountData />
                ) : roll === '2' ? (
                  <TraineesCountData />
                ) : (
                  <></>
                )}
                
              </div>
              
            </div>
          </Col>
          <Col xl={3} lg={3} md={12} sm={12}>
            <Calendar onChange={onChange} value={value} />
            <div className="upcomming-events">
              <div className="flex">
                <h2 className="headings">Upcoming Training</h2>
              </div>
              <div className="events__list">
                <div className="events_list_inside">
                  <div className="events">
                    <div className="event__circle"></div>
                    <div className="event__data">
                      <span className="title">IT Session</span>
                      <span className="descrip">
                        <span className="time">
                          <i className="uil uil-clock-three"></i>
                        </span>
                        <span className="text">
                          Tuesday, 17 May 10.00 AM to 1:00 PM
                        </span>
                      </span>
                    </div>
                  </div>
                  <div className="events active">
                    <div className="event__circle"></div>
                    <div className="event__data">
                      <span className="title">Face to Face QA</span>
                      <span className="descrip">
                        <span className="time">
                          <i className="uil uil-clock-three"></i>
                        </span>
                        <span className="text">
                          Tuesday, 17 May 11.00 AM to 1:30 PM
                        </span>
                      </span>
                    </div>
                  </div>
                  <div className="events">
                    <div className="event__circle"></div>
                    <div className="event__data">
                      <span className="title">IT Session</span>
                      <span className="descrip">
                        <span className="time">
                          <i className="uil uil-clock-three"></i>
                        </span>
                        <span className="text">
                          Thursday, 19 May 11.00 AM to 1:00 PM
                        </span>
                      </span>
                    </div>
                  </div>
                  <div className="events">
                    <div className="event__circle"></div>
                    <div className="event__data">
                      <span className="title">Face to Face QA</span>
                      <span className="descrip">
                        <span className="time">
                          <i className="uil uil-clock-three"></i>
                        </span>
                        <span className="text">
                          Tuesday, 17 May 10.00 AM to 1:00 PM
                        </span>
                      </span>
                    </div>
                  </div>
                  <div className="events">
                    <div className="event__circle"></div>
                    <div className="event__data">
                      <span className="title">IT Session</span>
                      <span className="descrip">
                        <span className="time">
                          <i className="uil uil-clock-three"></i>
                        </span>
                        <span className="text">
                          Tuesday, 17 May 10.00 AM to 1:00 PM
                        </span>
                      </span>
                    </div>
                  </div>
                  <div className="events">
                    <div className="event__circle"></div>
                    <div className="event__data">
                      <span className="title">Face to Face QA</span>
                      <span className="descrip">
                        <span className="time">
                          <i className="uil uil-clock-three"></i>
                        </span>
                        <span className="text">
                          Tuesday, 17 May 10.00 AM to 1:00 PM
                        </span>
                      </span>
                    </div>
                  </div>
                  <div className="events">
                    <div className="event__circle"></div>
                    <div className="event__data">
                      <span className="title">IT Session</span>
                      <span className="descrip">
                        <span className="time">
                          <i className="uil uil-clock-three"></i>
                        </span>
                        <span className="text">
                          Tuesday, 17 May 10.00 AM to 1:00 PM
                        </span>
                      </span>
                    </div>
                  </div>
                  <div className="events">
                    <div className="event__circle"></div>
                    <div className="event__data">
                      <span className="title">Face to Face QA</span>
                      <span className="descrip">
                        <span className="time">
                          <i className="uil uil-clock-three"></i>
                        </span>
                        <span className="text">
                          Tuesday, 17 May 10.00 AM to 1:00 PM
                        </span>
                      </span>
                    </div>
                  </div>
                  <div className="events">
                    <div className="event__circle"></div>
                    <div className="event__data">
                      <span className="title">IT Session</span>
                      <span className="descrip">
                        <span className="time">
                          <i className="uil uil-clock-three"></i>
                        </span>
                        <span className="text">
                          Tuesday, 17 May 10.00 AM to 1:00 PM
                        </span>
                      </span>
                    </div>
                  </div>
                  <div className="events">
                    <div className="event__circle"></div>
                    <div className="event__data">
                      <span className="title">Face to Face QA</span>
                      <span className="descrip">
                        <span className="time">
                          <i className="uil uil-clock-three"></i>
                        </span>
                        <span className="text">
                          Tuesday, 17 May 10.00 AM to 1:00 PM
                        </span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default Dashboard;
